<!--
 * @Author: wufei
 * @Date: 2020-08-10 10:06:12
 * @LastEditTime: 2020-08-13 17:12:58
 * @Description:
 * @FilePath: \mobile-revive\src\components\TitleComp\index.vue
-->
<template>
  <div class="title-comp">
    <div class="ttitle" :class="{'title-border':titleLine}">
      <div class="left">{{ title }}</div>
      <slot name="right" />
    </div>
    <div class="content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'TitleComp',
    props: {
        title: {
            type: String,
            default: ''
        },
        titleLine: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
  .title-comp {
    .title-border {
      border-bottom: .01rem /* 1/100 */ solid #EAEAEA;
      padding-bottom: .2rem !important;
    }
    .ttitle {
      display: flex;
      justify-content: space-between;
      padding:0;
      .left {
        font-size:.32rem /* 32/100 */;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height: .32rem;
      }

      .left::before {
        content:'';
        display:inline-block;
        width:.06rem /* 6/100 */;
        height:.32rem /* 30/100 */;
        background:rgba(39,97,255,1);
        vertical-align: bottom;
        margin-right:.15rem /* 15/100 */;
      }
    }

  }
</style>
